module.exports = __webpack_public_path__ + "resources/images/logo_bydehand-358e656c878194189a76b7eea0792fec-cache.jpg";